module.exports = __webpack_public_path__ + "static/logo-aa6ec67dcdb295b98a60c0a8d1ad3d92.webp";